export default "__VITE_ASSET__BX7tb0ds__"